import { render, staticRenderFns } from "./searchTournamentCard.vue?vue&type=template&id=2b82df1b&scoped=true&"
import script from "./searchTournamentCard.vue?vue&type=script&lang=js&"
export * from "./searchTournamentCard.vue?vue&type=script&lang=js&"
import style0 from "./searchTournamentCard.vue?vue&type=style&index=0&id=2b82df1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82df1b",
  null
  
)

export default component.exports